import { render, staticRenderFns } from "./GamePoints.vue?vue&type=template&id=7d99d6d8&"
import script from "./GamePoints.vue?vue&type=script&lang=ts&"
export * from "./GamePoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports